export default __webpack_public_path__ + "static/media/setaVirada.b364a1d1.png";